(() => {
  'use strict';

  const PARAMS = new URLSearchParams(window.location.search);
  const location = PARAMS.get('panthera_location');

  if (!location) return;

  const mobile = location === 'mobile';
  const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const MOBILE_FEE_SELLING_PLAN_ID = 3124658247;
  const MOBILE_FEE_VARIANTS = Object.freeze({
    29: 43145709617223,
    49: 43145709649991,
    79: 43145709682759
  });

  const bookingValues = {
    'Service Location': mobile ? 'Panthera Mobile Service' : 'Panthera Studio',
    'Reservation Policy Accepted': PARAMS.get('panthera_policy_confirmed') === '1' ? 'Confirmed' : '',
    'Mobile Address': mobile ? PARAMS.get('panthera_mobile_address') || '' : '',
    'Mobile City': mobile ? PARAMS.get('panthera_mobile_city') || '' : '',
    'Mobile Phone': mobile ? PARAMS.get('panthera_mobile_phone') || '' : '',
    'Mobile State': mobile ? PARAMS.get('panthera_mobile_state') || 'NJ' : '',
    'Mobile ZIP': mobile ? PARAMS.get('panthera_mobile_zip') || '' : '',
    'Mobile Zone': mobile ? PARAMS.get('panthera_mobile_zone') || '' : '',
    'Mobile Service Fee': mobile ? PARAMS.get('panthera_mobile_fee') || '' : '',
    'Mobile Fee Billing': mobile ? 'Due when service is fulfilled' : '',
    'Suitable Service Space': mobile && PARAMS.get('panthera_mobile_requirements_confirmed') === '1' ? 'Confirmed' : '',
    'Water Connection': mobile && PARAMS.get('panthera_mobile_requirements_confirmed') === '1' ? 'Confirmed' : '',
    'Electrical Connection': mobile && PARAMS.get('panthera_mobile_requirements_confirmed') === '1' ? 'Confirmed' : '',
    'Van Access': mobile && PARAMS.get('panthera_mobile_requirements_confirmed') === '1' ? 'Confirmed' : '',
    'Property / HOA Permission': mobile && PARAMS.get('panthera_mobile_requirements_confirmed') === '1' ? 'Confirmed' : ''
  };

  const hydrateForm = (form) => {
    if (!(form instanceof HTMLFormElement)) return;

    Object.entries(bookingValues).forEach(([propertyName, rawValue]) => {
      const value = String(rawValue || '').trim();
      const name = 'properties[' + propertyName + ']';
      let input = form.querySelector('input[name="' + CSS.escape(name) + '"]');

      if (!value) {
        input?.remove();
        return;
      }

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.dataset.pantheraBookingContext = 'true';
        form.appendChild(input);
      }

      input.disabled = false;
      input.value = value;
    });
  };

  const hydrateAll = () => {
    document
      .querySelectorAll('product-form-component form[data-type="add-to-cart-form"]')
      .forEach(hydrateForm);
  };

  const parseMobileFeeAmount = () => {
    const match = String(bookingValues['Mobile Service Fee'] || '').match(/(29|49|79)(?:\.00)?/);
    return match ? Number(match[1]) : 0;
  };

  const mobileFeeAmount = mobile ? parseMobileFeeAmount() : 0;
  const mobileFeeVariantId = mobile ? MOBILE_FEE_VARIANTS[mobileFeeAmount] || null : null;
  const mobileFeePlanId = mobile ? MOBILE_FEE_SELLING_PLAN_ID : null;
  let pendingMobileAdd = null;

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    return '$' + (Number.isInteger(amount) ? amount.toFixed(0) : amount.toFixed(2));
  };

  const renderFinancialSummary = () => {
    document.querySelectorAll('[data-panthera-service-financials]').forEach((summary) => {
      const baseCents = Number(summary.dataset.basePriceCents || 0);
      const depositCents = Number(summary.dataset.depositCents || 0);
      if (!baseCents || !depositCents) return;

      const feeCents = mobile ? mobileFeeAmount * 100 : 0;
      const fullTotalCents = baseCents + feeCents;
      const remainingCents = Math.max(0, fullTotalCents - depositCents);

      const baseNode = summary.querySelector('[data-panthera-base-service]');
      const feeNode = summary.querySelector('[data-panthera-mobile-fee]');
      const feeRow = summary.querySelector('[data-panthera-mobile-fee-row]');
      const totalNode = summary.querySelector('[data-panthera-full-total]');
      const dueNode = summary.querySelector('[data-panthera-due-today]');
      const remainingNode = summary.querySelector('[data-panthera-remaining]');
      const noteNode = summary.querySelector('[data-panthera-financial-note]');

      if (baseNode) baseNode.textContent = formatMoney(baseCents);
      if (feeNode) feeNode.textContent = '+' + formatMoney(feeCents);
      if (feeRow) feeRow.hidden = !mobile;
      if (totalNode) totalNode.textContent = formatMoney(fullTotalCents);
      if (dueNode) dueNode.textContent = formatMoney(depositCents);
      if (remainingNode) remainingNode.textContent = formatMoney(remainingCents);

      if (noteNode) {
        noteNode.textContent = mobile
          ? 'Only the reservation deposit is charged today. The Mobile Service Fee is included in the remaining balance and is due when the service is fulfilled.'
          : 'Only the reservation deposit is charged today. The remaining service balance is due when the service is fulfilled.';
      }

      summary.hidden = false;
    });
  };

  const refreshPdpContext = () => {
    window.requestAnimationFrame(() => {
      hydrateAll();
      renderFinancialSummary();
    });
  };

  const rollbackServiceLine = async (cart, variantId) => {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const serviceItem = items.find((item) =>
      String(item.variant_id) === String(variantId) &&
      item.properties &&
      item.properties['Service Location'] === 'Panthera Mobile Service'
    );

    if (!serviceItem?.key) return;

    const nextQuantity = Math.max(0, Number(serviceItem.quantity || 1) - 1);

    try {
      await fetch(rootPath + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: serviceItem.key,
          quantity: nextQuantity
        })
      });
    } catch (error) {
      console.error('[Panthera Mobile Fee] Rollback failed.', error);
    }
  };

  const addDeferredMobileFee = async (pending, cart) => {
    if (!pending?.feePlanId || !pending?.feeVariantId) return;

    try {
      const response = await fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: Number(pending.feeVariantId),
            quantity: 1,
            selling_plan: Number(pending.feePlanId),
            properties: {
              'Mobile Zone': bookingValues['Mobile Zone'] || '',
              'Mobile Service Fee': '$' + mobileFeeAmount,
              'Billing Timing': 'Due when service is fulfilled',
              'Service ZIP': bookingValues['Mobile ZIP'] || ''
            }
          }]
        })
      });

      if (!response.ok) {
        const body = await response.text();
        throw new Error(body || 'Unable to add deferred Mobile Service fee');
      }

      window.location.assign(rootPath + 'cart');
    } catch (error) {
      console.error('[Panthera Mobile Fee] Fee line failed.', error);
      await rollbackServiceLine(cart, pending.variantId);
      window.alert(
        'We could not prepare the Mobile Service fee correctly, so the reservation was not completed. Please try again.'
      );
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshPdpContext, { once: true });
  } else {
    refreshPdpContext();
  }

  document.addEventListener('variant:update', refreshPdpContext);
  document.addEventListener('shopify:section:load', refreshPdpContext);
  window.addEventListener('pageshow', refreshPdpContext);

  if (!mobile) return;

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('product-form-component form[data-type="add-to-cart-form"]')) return;

      const productForm = form.closest('product-form-component');
      if (!productForm) return;

      if (!mobileFeeVariantId) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.alert('We could not determine the Mobile Service zone fee. Return to Services and verify the ZIP Code.');
        return;
      }

      const variantId = form.querySelector('input[name="id"]')?.value || '';
      pendingMobileAdd = {
        variantId,
        productId: productForm.dataset.productId || '',
        feeVariantId: mobileFeeVariantId,
        feePlanId: mobileFeePlanId
      };
    },
    true
  );

  document.addEventListener('cart:update', (event) => {
    if (!pendingMobileAdd) return;

    const detail = event.detail || {};
    const data = detail.data || {};

    if (data.source !== 'product-form-component') return;

    if (data.didError) {
      pendingMobileAdd = null;
      return;
    }

    if (pendingMobileAdd.productId && String(data.productId || '') !== String(pendingMobileAdd.productId)) {
      return;
    }

    const pending = pendingMobileAdd;
    pendingMobileAdd = null;
    addDeferredMobileFee(pending, detail.resource);
  });
})();